"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
var firefly_shared_ts_1 = require("firefly-shared-ts");
var event_1 = require("../helpers/event");
var task_1 = require("../helpers/task");
var browser_1 = require("../helpers/browser");
var EventInterceptor = /** @class */ (function () {
    function EventInterceptor() {
    }
    EventInterceptor.prototype.apply = function (json, persistMethod, isInternalApp) {
        var currentTimezone = firefly_shared_ts_1.Device.getCurrentTimezone();
        var eventId = firefly_shared_ts_1.Event.createEventId();
        var orientation = firefly_shared_ts_1.Browser.getScreenOrientation();
        var previousPageName = (0, event_1.getPrevPageName)(persistMethod);
        var previousPageType = (0, event_1.getPrevPageType)(persistMethod);
        var sdkVersion = (0, event_1.getSdkVersion)();
        var sessionHit = (0, event_1.getSessionHit)(persistMethod);
        var systemTime = firefly_shared_ts_1.Event.getSystemTime();
        var timezoneOffset = firefly_shared_ts_1.Device.getTimezoneOffset();
        var oldInterceptorJSON = {
            application: { id: eventId },
            appState: { previousPageName: previousPageName, previousPageType: previousPageType, sessionHit: sessionHit },
            guest: { currentTimezone: currentTimezone, systemTime: systemTime, timezoneOffset: timezoneOffset }
        };
        var newInterceptorJSON = {
            application: { sdkVersion: sdkVersion },
            device: { currentTimezone: currentTimezone, systemTime: systemTime, timezoneOffset: timezoneOffset },
            event: { id: eventId, sessionHit: sessionHit },
            view: {
                previousName: previousPageName,
                previousType: previousPageType,
                orientation: orientation
            },
            browser: undefined,
            task: undefined
        };
        if (isInternalApp) {
            var sessionId = void 0, task = void 0;
            sessionId = (0, browser_1.setInternalAppSessionId)();
            task = (0, task_1.setInternalAppTaskNode)(json, systemTime);
            newInterceptorJSON.browser = { sessionId: sessionId };
            newInterceptorJSON.task = task;
        }
        var interceptorJSON = firefly_utilities_ts_1.Utilities.extend(oldInterceptorJSON, newInterceptorJSON);
        (0, event_1.setPrevPageName)(json, persistMethod);
        (0, event_1.setPrevPageType)(json, persistMethod);
        return firefly_utilities_ts_1.Utilities.extend(json, interceptorJSON);
    };
    return EventInterceptor;
}());
exports.default = EventInterceptor;
